import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature9',
    },
    page: {
      className: 'home-page feature9-page',
    },
    content: {
      className: 'feature9-content',
      playScale: 0.3,
      always: false,
      left: {
        className: 'feature9-content-img',
        children:
          'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(7).png',
      },
      right: {
        className: 'feature9-content-right',
        title: {
          className: 'feature9-content-right-title',
          children: [
            {
              name: '标题0',
              className: 'feature9-content-right-title-box',
              children: '园区荣誉',
            },
          ],
        },
        box: {
          className: 'feature9-content-right-box',
          children: [
            {
              name: '项目0',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '国家级经济技术开发区',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
            {
              name: '项目1',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '中德智能网联汽车示范基地',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
            {
              name: '项目2',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '全国投资潜力百强区',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
            {
              name: '项目3',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '国家新型工业化汽车产业示范基地',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
            {
              name: '项目4',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '中法成都生态园',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
            {
              name: '项目5',
              className: 'feature9-content-right-box-item',
              title: {
                className: 'feature9-content-right-box-item-title',
                children: '国家生态工业示范区',
              },
              img: {
                className: 'feature9-content-right-box-item-img',
                children:
                  'https://imm.86links.com/assets/landing/images/%E5%8B%8B%E7%AB%A0%402x.png',
              },
            },
          ],
        },
      },
    },
  },
};
